import createVueComponent from '../createVueComponent';

const ChevronFirst = createVueComponent('ChevronFirstIcon', [
  ['path', { d: 'm17 18-6-6 6-6', key: '1yerx2' }],
  ['path', { d: 'M7 6v12', key: '1p53r6' }],
]);

export default ChevronFirst;
